define('boxes/forgotten-password-box',['jquery',  'boxes/box', 'boxes/events/loginEvent', 'boxes/helpers/loginHelper', 'all/comeon', 'boxes/helpers/tooltip', 'boxes/helpers/box-loading'], function ($, box, loginEvent, loginHelper, comeon, tooltip, loading) {
    'use strict';

    var backToLoginCallback = function(){};

    function init(forgottenPasswordBox){

        forgottenPasswordBox.$controller.on(loginEvent.FORGOT_PASSWORD, function (event) {
            event.preventDefault();
            forgottenPasswordBox.model.shouldVerify = true;
        });

        forgottenPasswordBox.$controller.on(loginEvent.SET_BACK_TO_LOGIN_CALLBACK, function (event, backToLoginCallbackRef) {
            event.preventDefault();
            backToLoginCallback = backToLoginCallbackRef;
        });

        forgottenPasswordBox.$controller.on(loginEvent.EMAIL_IS_VERIFIED, function (event, data) {
            event.preventDefault();
            forgottenPasswordBox.$box.find('input[name=PARAM_EMAIL]').filter(':visible').val(data.PARAM_EMAIL);
            forgottenPasswordBox.$box.find('a.continue-link').click();
        });

        forgottenPasswordBox.$box.find('a.continue-link').click(function (event) {
            event.preventDefault();
			loading.showLoading(forgottenPasswordBox.$box);
            var email = forgottenPasswordBox.$box.find('input[name=PARAM_EMAIL]').filter(':visible').val();
            var parameters = {PARAM_EMAIL: email};
            $.post('/pp?flow=ForgotPassword', parameters, function (data) {
                forgotPasswordSuccess(forgottenPasswordBox, data, email);
            });
        });

		forgottenPasswordBox.$box.find('input[name="PARAM_EMAIL"]').on('input', function() {
			tooltip.hidePopover($(this));
			if($(this).val().length > 0) {
				forgottenPasswordBox.$box.find('a.continue-link').removeClass('disabled');
			} else {
				forgottenPasswordBox.$box.find('a.continue-link').addClass('disabled');
			}
		});

        var $form = forgottenPasswordBox.$box.find('form');
        setupValidationConfiguration($form);
		setupEnterHandler($form);

        var $elements = forgottenPasswordBox.$box.find(':input');
        loginHelper.setupFocusPopover($elements);

    }

    function setupValidationConfiguration($form) {

        var validationConfiguration = {
            errorClass: loginHelper.ERROR_CLASS,
            validClass: loginHelper.VALID_CLASS,
            rules: {
                PARAM_EMAIL: {
                    required: true,
					email: true
                }
            },

            highlight: loginHelper.highlight,
            unhighlight: loginHelper.unHighlight,
            errorPlacement: loginHelper.errorPlacement
        };

        $form.validate(validationConfiguration);

    }

	function setupEnterHandler($form) {
		$form.find('input').each(function(i, val) {
			$(val).off('keypress').on('keypress', function(event) {
				if(event.which === 13) {
					event.preventDefault();
					$form.parent().find('.continue-link').click();
				}
			});
		});
	}

    function forgotPasswordSuccess(forgottenPasswordBox, response, email){
		loading.removeLoading(forgottenPasswordBox.$box);
        // response = $.parseJSON(response);
        if (response.RESULT !== 'OK') {
            //loginHelper.handleErrorResponse(response, forgottenPasswordBox);
			tooltip.showPopover(forgottenPasswordBox.$box.find('input[name="PARAM_EMAIL"]').parent(), response.ERROR);
        } else {
            // Everything went alright in a matter of speaking
            // Check the code to see what the next step is
            if (response.CODE === 'REG_UNVERIFIED_EMAIL') {
                // ForgotPW1.java response
                // This happens if the player have not yet verified his email. Then he will have to do that.
                // Open dialog forgotPWEmailVerification.jsp which in turn post to ResendEmailVerification,
                // which in turn returns error or code EMAIL_VER_SENT, which ends the flow
                forgottenPasswordBox.$controller.trigger(loginEvent.VERIFY_EMAIL, email);
                forgottenPasswordBox.$controller.nextBox();
            } else if (response.CODE  === 'REG_DEPOSIT_WITHDRAW') {
				//THIS IS DISABLED AS PER THE NEW RESET PASSWORD FLOWS

                // ForgotPW1.java response
                // This happens if the player have a verified email and mobile and thereby can do deposits,
                // then he will have to write his postal code and mobile phone number
                // Before a temp password can be generated and sent from ForgotPW2.java
                // This extra popup that opens forgotPW2.jsp
                // That jsp will in turn post to ForgotPW2.java,
                // which in turn returns error or code TEMP_PASSWORD_SENT_SMS, which is end of flow
				/*
                var mobileCountryCode = response.PARAM_MOBILE_PHONE_COUNTRY_CODE;
				forgottenPasswordBox.$controller.trigger(loginEvent.SKIP_EMAIL_VERIFICATION);
                forgottenPasswordBox.$controller.trigger(loginEvent.VERIFY_POSTAL_AND_MOBILE, mobileCountryCode);
                forgottenPasswordBox.$controller.nextBox();
                */
            } else if (response.CODE === 'TEMP_PASSWORD_SENT_EMAIL' ) {
                // ForgotPW1.java gives immediately a  final positive response
                // The close and confirm on this one will execute doneCallback(), we don't need to close
				/*
                loginHelper.showOneButtonPopup(forgottenPasswordBox,'', response.TEXT, response.BUTTON_TEXT, function(){
                    backToLoginCallback();
                });*/
				var $verificationPopup = loginHelper.showVerifyCodePopup(forgottenPasswordBox, "Identity Verification", response.TEXT, response.IN_BUTTON_TEXT, response.BUTTON_TEXT,
					function() {
						var parameters = {
							"PARAM_EMAIL": forgottenPasswordBox.$box.find('input[name=PARAM_EMAIL]').val(),
							"PARAM_CODE":  forgottenPasswordBox.$box.find('input[name=POPUP_INPUT_FIELD]').val()
						}
						$.post('/pp?flow=ResetPasswordCode', parameters, function (data) {
							forgottenPasswordBox.$controller.boxes[1].model.email = parameters.PARAM_EMAIL;
							forgottenPasswordBox.$controller.boxes[1].model.code = parameters.PARAM_CODE;
							if (data.RESULT === "OK") {
								forgottenPasswordBox.$controller.goToBox(forgottenPasswordBox.$controller.boxes[1]);
							}
							else if (data.RESULT === "NOT_OK") {
								loginHelper.handleVerifyCodeErrorResponse(data, forgottenPasswordBox);
							}
						});
					},
					function () {
						console.log('cancel');
					}, true);
				var $verifyCodeInput = $verificationPopup.find('input');
				$verifyCodeInput.on('input', function () {
					tooltip.hidePopover($(this).parent());
					if($verifyCodeInput.val().length === 4) {
						$verificationPopup.find('.confirm').removeClass('disabled');
					} else {
						$verificationPopup.find('.confirm').addClass('disabled');
					}
				});
				$verifyCodeInput.on('keypress', function(event) {
					if (event.which === 13) {
						event.preventDefault();
						if(!$verifyCodeInput.hasClass('disabled')) {
							$verificationPopup.find('.confirm').click();
						}
					}
				});
			}
        }
    }


    var view = {
            render: function () {}
        },
        model = {
            shouldVerify: undefined,
            init: function (forgottenPasswordBox) {
                init(forgottenPasswordBox);
            },
            beforeRender: function (forgottenPasswordBox) {
				//make sure popups are gone for sure
				forgottenPasswordBox.$box.find('.overlay').remove();

                var shouldVerifyPromise = comeon.promise.create();

                if (forgottenPasswordBox.model.shouldVerify) {
                    shouldVerifyPromise.resolve();
                } else {
                    shouldVerifyPromise.reject();
                }

                return [shouldVerifyPromise.promise()];
            },
            afterRender: function () {}
        };

    return {
        create: function ($box, $controller, defaultShouldVerify) {
            model.shouldVerify = defaultShouldVerify;
            return box.create($box, $controller, view, model);
        }
    };
});

